import styled from 'styled-components';

import { CheckBoxWrapper } from '../../../PlayButtonCheckbox/Wrapper';

export const Wrapper = styled.div`
  margin-bottom: 18px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 7px;
  }

  ${CheckBoxWrapper} {
    margin-bottom: 20px;
  }
`;

export const SelectionWrapper = styled.div`
  margin-bottom: 22px;
`;
